// IndustrySignupForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';



const IndustrySignupForm = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'INDUSTRY',
    companyName:'',
    phoneNumber:'',
    
  });

    const navigate = useNavigate();

  const[ serverResponse, setServerResponse] = useState(''); // State to store server response if error

  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error message when the confirm password field is changed
    // if (name === 'confirmPassword' || name === 'password') {
    //   if (formData.password === value || formData.confirmPassword === value) {
    //     setError(''); // Clear error if passwords are matching while typing
    //   }
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    if (formData.phoneNumber.length != 10) {
      setError('Please give a valid Phone number');
      return;
    }

    setError('');

    // Check if passwords match
    // if (formData.password !== formData.confirmPassword) {
    //   setError('Passwords do not match');
    //   return;
    // }

    // Clear error if passwords match and proceed
    // setError('');
    // console.log('Form Submitted', formData);
    // Add your form submit logic here
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/api/users/signup`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        // Handling different response statuses
        if (response.status === 400 || response.status === 500 || response.status === 401) {
          setServerResponse('Error signing up');
        //   setInvalid(true);
        }
        if(response.status === 422){
          setServerResponse('Email already exists');
        }
        if(response.status === 429){
          setServerResponse('Too many requests');
          alert('Too many requests try after some time');
        }

        if (response.ok) {
          const responseData = await response.json();
          // Assuming the response contains a token field
          const token = JSON.stringify(responseData);
          const userDetails = responseData;
          // console.log(userDetails)
          // console.log("success")
          navigate('/confirm-email');


          
          localStorage.setItem('token', token);
        } else {
          console.error('Error logging in:', response.statusText);
          // Handle error if needed
        }
      } catch (error) {
        console.error('Error logging in:', error);
        // Handle error if needed
      }
  };

  return (
    <div className='  px-6 py-2 rounded-b-2xl bg-gradient-to-r from-[var(--color-contrast)] to-[var(--color-fill)] max-w-md mx-auto  flex flex-col justify-center items-center'>
      {/* <p className='font-medium text-lg font-custom text-gray-500 text-center mb-6'>Please enter your details to sign up.</p> */}
      <form onSubmit={handleSubmit} className='space-y-5'>
        {/* Name Input */}
        <div>
          <label htmlFor="name" className='text-lg font-medium font-custom text-white'>Name</label>
          <input
            id="username"
            name="username"
            type="text"
            value={formData.username}
            onChange={handleChange}
            className='w-full text-gray-300 border-b border-blue-300 p-2 mt-1 bg-transparent font-custom'
            placeholder='Enter your name'
            required
          />
        </div>

        {/* Email Input */}
        <div>
          <label htmlFor="email" className='text-lg font-medium font-custom text-white'>Email</label>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className='w-full text-gray-300 border-b border-blue-300 p-2 mt-1 bg-transparent font-custom'
            placeholder='Enter your email'
            required
          />
        </div>

        {/* CompanyName Input */}
        <div>
          <label htmlFor="companyName" className='text-lg font-medium font-custom text-white'>Company Name</label>
          <input
            id="companyName"
            name="companyName"
            type="text"
            value={formData.companyName}
            onChange={handleChange}
            className='w-full text-gray-300 border-b border-blue-300 p-2 mt-1 bg-transparent font-custom'
            placeholder='Enter your company name'
            required
          />
        </div>

        {/* Password Input */}
        <div>
          <label htmlFor="password" className='text-lg font-medium font-custom text-white'>Password</label>
          <input
            id="password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            className='w-full text-gray-300 border-b border-blue-300 p-2 mt-1 bg-transparent font-custom'
            placeholder='Enter your password'
            required
          />
        </div>

       {/* Phone Input */}
       {/* Phone Input */}
       <div>
  <label htmlFor="phoneNumber" className="text-lg font-medium font-custom text-white">
    Phone Number
  </label>
  <input
    id="phoneNumber"
    name="phoneNumber"
    type="text"
    value={formData.phoneNumber}
    onChange={(e) => {
      const input = e.target.value;
      // Allow only numbers and limit to 10 digits
      if (/^\d{0,10}$/.test(input)) {
        handleChange(e); // Only call handleChange if valid
      }
    }}
    className="w-full border-b text-gray-300 border-blue-300 p-2 mt-1 bg-transparent font-custom"
    placeholder="Phone number"
    required
  />
</div>

        {/* Error Message */}
        {error && <p className='text-center text-red-600 font-semibold mt-3'>{error}</p>}
        {serverResponse && <p className='text-center text-red-600 font-semibold mt-3'>{serverResponse}</p>}

        {/* Submit Button */}
        <div className='mt-6'>
          <button
            type="submit"
            className='w-full flex p-2 rounded-xl mb-2 font-custom  font-semibold items-center justify-center bg-white text-gray-700 gap-2 active:scale-[0.98] active:duration-75 hover:scale-[1.01] ease-in-out transition-all'
          >
            Sign Up
          </button>
        </div>
      </form>
    </div>
  );
};

export default IndustrySignupForm;
